import { gql } from '@apollo/client';

const GET_TICKETS = gql`
  query tickets($params: QueryParams) {
    tickets(params: $params) {
      info {
        count
      }
      results {
        id
        status
        user {
          id
          firstName
          lastName
        }
        location {
          id
          name
        }
        client {
          id
          user {
            id
            firstName
            lastName
          }
        }
        order {
          id
          reference
        }
        history {
          id
          sender
          message
          createdAt
        }
        createdAt
      }
    }
  }
`;

export { GET_TICKETS };
